angular.module('impactx.logouttimer', []);